import type { Fields } from "@smartsuite/smartsuite-client";
import { ValueDescription_T } from "@smartsuite/automation-engine-api";

export const ssTypes: ValueDescription_T[] = [ValueDescription_T.EMAIL];

export const ssFields: Fields[] = [
  "emailfield",
  "userfield",
  "firstcreatedfield",
  "lastupdatedfield",
  "formulafield",
  "lookupfield",
  "teamfield",
];

export const generalTypes: ValueDescription_T[] = [
  ValueDescription_T.EMAIL,
  ValueDescription_T.MEMBER,
];

export const emailContextSpecificFields: string[] = [
  "context-output-user-who-took-action.email",
];

export const phoneContextSpecificFields: string[] = [
  "context-output-user-who-took-action.phone",
];

export const memberContextSpecificFields: string[] = [
  "context-output-current-user",
  "context-output-user-who-took-action",
  "context-output-user-who-took-action.user-id",
];
